import { render } from "./Flat3.vue?vue&type=template&id=7aaf32b4"
import script from "./Flat3.vue?vue&type=script&lang=js"
export * from "./Flat3.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__